'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { ConsentGate } from '@/features/gdpr/consent-gate'
import { THIRD_PARTY_PURPOSE } from '@/features/gdpr/use-purpose-consent'
import { Language, Locale, parseLanguageFromLocale } from '@/setup/locales'

type MoinAiChatProps = { locale: Locale }

const EXCLUDED_PATHS = [
    '/faq',
    '/contact',
    'kontakt',
    '/urbansportsclub',
    '/lieferando',
    '/flink',
    '/sumup',
    '/lp/cooperations',
    '/lp/voucher-campaigns',
    '/tiktok-filter',
]

const MOIN_AI_CONFIG = {
    [Language.DE]: {
        id: 'zLktLgm0',
        channelId: 'zLktLgm0',
    },
    [Language.EN]: {
        id: 'zLktLgm0',
        channelId: 'zLktLgm0-en',
    },
    [Language.NL]: undefined,
}

export function MoinAiChat({ locale }: MoinAiChatProps) {
    const pathname = usePathname()
    const language = parseLanguageFromLocale(locale)

    const isExcludedPage = EXCLUDED_PATHS.some((path) => pathname.includes(path))
    if (isExcludedPage) return null

    const config = MOIN_AI_CONFIG[language]

    if (!config) return null

    return (
        <ConsentGate
            integrationId="moin-ai"
            purposeId={THIRD_PARTY_PURPOSE}
            placeholder={() => null}
        >
            <Script
                key={language}
                id="moinloader"
                src={`https://widget.moin.ai/moin-loader.js?id=${config.id}&channelid=${config.channelId}`}
                strategy="lazyOnload"
            />
        </ConsentGate>
    )
}
